var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 13.5C8.85 13.5 7.5 14.85 7.5 16.5V19.5C7.5 21.15 8.85 22.5 10.5 22.5H12V28.5H15V22.5H16.5L24 27V9L16.5 13.5H10.5ZM18.045 16.065L21 14.295V21.705L18.045 19.935L17.325 19.5H16.5H10.5V16.5H16.5H17.325L18.045 16.065Z",
    fill: "#3B3E66"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.75 18C27.75 16.005 26.88 14.205 25.5 12.975V23.01C26.88 21.795 27.75 19.995 27.75 18Z",
    fill: "#3B3E66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertMessage);
export default __webpack_public_path__ + "static/media/AlertMessage.7a2c245bd4d900907c9d410878406179.svg";
export { ForwardRef as ReactComponent };